import {State, Action, Selector, StateContext} from '@ngxs/store';
import {
  GetReportsCount
} from './report.actions';
import {Injectable} from '@angular/core';
import {ReportService} from '@shared/service/report/report.service';

export interface ReportStateModel {
  reportCount: any;
}

@State<ReportStateModel>({
  name: 'report',
  defaults: {
    reportCount: {}
  }
})
@Injectable()
export class ReportState {
  constructor(private reportService: ReportService) {
  }

  @Selector()
  static getReportCount(state: ReportStateModel) {
    return state.reportCount;
  }

  @Action(GetReportsCount)
  getReportCount({patchState}: StateContext<GetReportsCount>) {
    return this.reportService.getReportCount()
      .then((reportCount: any) => {
        patchState({
          reportCount
        });
      });
  }
}
